import { useTranslation } from "react-i18next";
import { BookingPageDraftResponse } from "../../features/trial-requests/contracts/BookingPageDraftResponse";
import { BookingPageSettingsResponse } from "../../features/trial-requests/contracts/BookingPageSettingsResponse";

const stripTags = (html: string): string => html.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();

interface Props {
  draft: BookingPageDraftResponse;
  mode: "generate" | "improve";
  settings: BookingPageSettingsResponse;
  busy: boolean;
  onApply: () => void;
  onDiscard: () => void;
}

/** The assistant's page proposal: compact preview + apply / discard. */
const WebsiteAiDraftPreview = ({ draft, mode, settings, busy, onApply, onDiscard }: Props) => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="with-border max-h-64 overflow-y-auto rounded-2xl p-3">
        <p className="text-sm font-semibold text-grey-20 dark:text-white">{draft.headline}</p>
        <p className="mt-1 text-sm text-grey-30 dark:text-grey-70">{draft.introText}</p>
        <p className="mt-2 text-sm text-grey-40 dark:text-grey-80">{stripTags(draft.aboutText)}</p>
        {draft.locationText && (
          <p className="mt-2 text-sm text-grey-40 dark:text-grey-80">{draft.locationText}</p>
        )}
        {draft.services.length > 0 && (
          <ul className="mt-2 text-sm text-grey-30 dark:text-grey-70">
            {draft.services.map((service) => (
              <li key={service.title} className="mt-1">
                <span className="font-medium">{service.title}</span> — {service.description}
              </li>
            ))}
          </ul>
        )}
      </div>
      <p className="mt-2 text-xs text-grey-40 dark:text-grey-80">
        {mode === "improve"
          ? t("website.aiDraftKeepsPrices", "Your prices, icons and pictures stay untouched.")
          : settings.services.length > 0
            ? t("website.aiDraftKeepsServices", "Your existing services stay untouched.")
            : t("website.aiDraftNoPrices", "Add your prices to the services after applying.")}
      </p>
      <div className="mt-3 flex gap-2">
        <button type="button" className="btn btn-primary" onClick={onApply} disabled={busy}>
          {t("website.aiDraftApply", "Apply draft")}
        </button>
        <button type="button" className="btn btn-secondary" onClick={onDiscard} disabled={busy}>
          {t("website.aiDraftDiscard", "Discard")}
        </button>
      </div>
    </div>
  );
};

export default WebsiteAiDraftPreview;
